<template>
    <facet-template
        :show-clear-link="isFiltered"
        v-bind="$attrs"
        @clear="clearSelectedMakes"
        :expand-collapse="makeSelectorExpanded"
    >
        <div slot="facetLabel">
            <b-link class="toggleable-label" @click="toggleMakeListContainer()">
                {{ title }}
                <small class="font-italic font-weight-normal" v-if="value.length>0">
                    ({{ value.length }})
                </small>
            </b-link>
        </div>

        <div class="container">
            <div class="row">
                <div
                    ref="makeListContainer"
                    :class="['expanded', 'make-list']"
                    class="col-12 p-0"
                >
                    <div
                        v-for="make in makes"
                        :key="make.id"
                        class="
                            make-list-item
                            d-flex
                            justify-content-between
                            align-items-center
                            mb-2
                        "
                        :class="{ 'disabled-make': disabled }"
                        @click="toggleMakeSelection(make)"
                    >
                        <make-row
                            :make="make"
                            :selected="isMakeSelected(make)"
                            :path="path"
                            icon-class="mr-3"
                        />
                    </div>
                </div>
            </div>
        </div>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";
import MakeRow from "./components/MakeRow";
import orderBy from "lodash/orderBy";
import isEmpty from "lodash/isEmpty";
import pullAll from "lodash/pullAll";
import each from "lodash/each";
import includes from "lodash/includes";

export default {
    name: "MakeFacet",

    components: {
        MakeRow,
        FacetTemplate,
    },

    props: {
        value: {
            type: Array,
            required: true,
        },
        available: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: "Makes",
        },
        path: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            makeSelectorExpanded: false,
        };
    },

    computed: {
        makes() {
            return orderBy(
                this.available,
                [(make) => make.name.toLowerCase()],
                ["asc"]
            );
        },
        isFiltered() {
            return !isEmpty(this.value);
        },
    },

    watch: {
        value(oldVal, newVal) {
            const makesToRemove = pullAll(newVal, oldVal);

            each(makesToRemove, (selectedMakeName) => {
                this.$emit("remove", selectedMakeName);
            });
        },
    },

    methods: {
        clearSelectedMakes() {
            this.value.forEach((selectedMakeName) => {
                this.$emit("remove", selectedMakeName);
            });
            this.$emit("input", []);
        },
        toggleMakeSelection(clickedMake) {
            if (this.disabled) {
                //do nothing
                return;
            }

            // collection of selected makes is a list of make ids as String
            const makeAlreadySelected = this.isMakeSelected(clickedMake);

            if (!makeAlreadySelected) {
                this.addMakeToFilters(clickedMake.name);
            } else {
                this.removeMakeFromFilters(clickedMake.name);
            }
        },
        isMakeSelected(make) {
            return includes(this.value, make.name);
        },
        addMakeToFilters(selectedMakeName) {
            this.$emit("input", this.value.concat(selectedMakeName));
        },
        removeMakeFromFilters(selectedMakeName) {
            this.$emit(
                "input",
                this.value.filter((makeName) => makeName !== selectedMakeName)
            );
            this.$emit("remove", selectedMakeName);
        },
        toggleMakeListContainer() {
            this.makeSelectorExpanded = !this.makeSelectorExpanded;
        },
    },
};
</script>
<style lang="scss" scoped>
.make-list-item {
    cursor: pointer;

    &.disabled-make {
        opacity: 0.5;
        cursor: not-allowed;
    }
}
.make-list.expanded {
    max-height: 310px;
    overflow: auto;
}
.toggleable-label {
    color: #4a4a4a;
    text-decoration: none;
}
</style>
